import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import * as error from '../../shared/components/error-summary/error-handler.function';
import * as _ from 'lodash';
import { StopAddress } from 'app/shared/models/timetables.model';

declare const Modernizr: any;

@Injectable()
export class ReferenceDataService {
  stops: StopItem[];
  constructor(private http: Http) { }

  getStops = () => {
    const url = `/umbraco/api/travel/GetStops`;
    return this.http.get(url)
      .map(this.extractJson)
      .catch(error.handleError);
  }

  private extractJson(res: Response) {
    return res.json();
  }

  public testLocationEnabled(onSuccessfulLocationRequest, onFailedLocationRequest) {
    const locationRequestOptions = { // options
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    navigator.geolocation.getCurrentPosition(onSuccessfulLocationRequest, onFailedLocationRequest, locationRequestOptions);
  }

  public addDistanceToStops = (stops: Array<StopItem>, userCoords: Coords) => {
    const setDistanceOnStop = (stop: StopItem) => {
      const lat = stop.Addresses[stop.AddressNumber - 1].Latitude;
      const long = stop.Addresses[stop.AddressNumber - 1].Longitude;
      if (lat !== 0 && stop.Longitude !== 0) {
        stop.distance = this.calculateDistance(userCoords.latitude,
          userCoords.longitude,
          lat,
          long);
      } else {
        stop.distance = 99999999999; // determine it as far away...
      }
    };

    if (!Modernizr.geolocation) {
      return stops;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    }, onLocationBeingFound = (pos) => {
      try {
        userCoords = pos.coords;
        _.each(stops, setDistanceOnStop);
        this.stops = stops;
      } catch (err) {
        console.error(`ERROR(${err.code}): ${err.message}`);
      }
      return stops;
    }, onError = err => {
      console.error(`ERROR(${err.code}): ${err.message}`);
    };

    if (!userCoords) {
      navigator.geolocation.getCurrentPosition(onLocationBeingFound, onError, options);
    } else {
      _.each(stops, setDistanceOnStop);
      return stops;
    }
    return stops;
  }

  private calculateDistance = (lat1, lon1, lat2, lon2) => {
    const rlat1 = Math.PI * lat1 / 180,
      rlat2 = Math.PI * lat2 / 180,
      theta = lon1 - lon2,
      rtheta = Math.PI * theta / 180;
    let dist = Math.sin(rlat1) * Math.sin(rlat2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.cos(rtheta);

    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    // I quickly converted miles to km. Still not correct, maybe need to use google api to calculate actual walking/road distance?
    dist = dist * 1.6;
    return dist;
  }
}

export class StopItem {
  Address: string;
  Addresses: StopAddress[];
  AddressNumber: number;
  Code: string;
  Description: string;
  Latitude: number;
  Longitude: number;
  State: string;
  // added by function
  distance: number;

  public toString() {
    return this.Code;
  }
}

export class Coords {
  latitude: number;
  longitude: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reference-data.service.ts